
import { reactive, onMounted } from 'vue';
const modals = {};

function createModal(id) {
    console.log(id)
    modals[id] = reactive({
        instance: null,
    });

    onMounted(() => {
        try {
            modals[id].instance = new bootstrap.Modal(`#${id}`, {});
        } catch (e) {
            //console.log(e)
        }
    });

    return {
        show: () => {
            if (modals[id]?.instance) {
                modals[id].instance.show();
                console.log(`Modal ${id} is shown.`);
            }

        },
        hide: () => {
            if (modals[id]?.instance) {
                modals[id].instance.hide();
                console.log(`Modal ${id} is hidden.`);
            }
        },
    };
}

export { createModal };
